import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // или 'auto' для мгновенной прокрутки
    });
  }, [pathname]); // Зависимость от pathname гарантирует, что эффект сработает при каждом изменении маршрута

  return null; // Компонент не рендерит ничего
};

export default ScrollToTop;